module.exports = __webpack_public_path__ + "static/media/carta_7.4224e5ba.jpg";